import React, { Component } from "react";
import AppContext from "../../appContext";
import Swal from "sweetalert2";
import { swalOnOpen } from "../../shared/utils/swal-animations";
import Input from "../../components/inputs/input";
import AutoCompleteSelect from "../../components/autocomplete-select/autocomplete-select";
import VoucherInput from "../../shared/components/generic/voucher-input/voucher-input";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { CircularProgress, Collapse, Typography, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Paper, Radio, Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import VoucherEmpty from "../../shared/components/generic/voucher-empty/voucher-empty";
import CnpjUtils from "../../shared/utils/CnpjUtils";
import "./../lente-pronta.css";

const FRASE_RODAPE = "Em caso de dúvidas, entre em contato com o laboratório.";

class LenteProntaEtapaDois extends Component {
  constructor(props) {
    super(props);
    this.autoRef = React.createRef();
    this.state = {
      produtos: [],
      placeholder: "Carregando...",
      produtoDisabled: true,
      voucherPactoCode: props.pacto?.selectedVoucher?.codigo || "",
      voucherBlurred: !!(props.pacto?.selectedVoucher?.codigo),
      selectedPilar: props.pacto?.selectedVoucher?.pilar || "",
      selectedQuantidade: "",
      selectedMacrocarga: "",
    };

    LenteProntaEtapaDois.contextType = AppContext;
    this.handleChangeAutocomplete = this.handleChangeAutocomplete.bind(this);
    this.getProdutos = this.getProdutos.bind(this);
  }

  componentDidMount() {
    this.getTipoProdutoEProdutos();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.labId && this.props.labId) {
      this.getTipoProdutoEProdutos();
    }
    if (
      prevProps.dados_empresa_faturamento_cnpj !== this.props.dados_empresa_faturamento_cnpj &&
      this.props.labId
    ) {
      const cnpjLimpo = CnpjUtils.cleanCnpj(this.props.dados_empresa_faturamento_cnpj);
      if (cnpjLimpo.length === 14) {
        this.getTipoProdutoEProdutos();
      }
    }
    if (prevProps.pacto?.useVoucher && !this.props.pacto?.useVoucher && this.state.selectedPilar) {
      this.setState({ selectedPilar: "" });
    }
    if (prevProps.linhaProduto?.codigo !== this.props.linhaProduto?.codigo && this.state.selectedPilar) {
      this.setState({ selectedPilar: "" });
    }
  }

  exibirErroSwal(mensagem) {
    Swal.fire({
      html: `${mensagem}<br/><br/><span style="font-size:0.875rem;color:#6c757d">${FRASE_RODAPE}</span>`,
      icon: "warning",
      title: "Aviso",
      width: "600px",
      confirmButtonColor: "#00518b",
      customClass: { confirmButton: "x-follow-order__filter-btn" },
      onOpen: swalOnOpen,
    });
  }

  getTipoProdutoEProdutos() {
    const labId = this.props.labId;
    if (!labId) return;

    const requestOptions = {
      method: "POST",
      body: JSON.stringify({ laboratorio: labId }),
      headers: new Headers({
        Authorization: "Bearer " + sessionStorage.getItem("session_token"),
      }),
    };

    fetch(process.env.REACT_APP_LABS_API + "get_produtos_lente_pronta.php", requestOptions)
      .then(async response => {
        let body = null;
        try { body = await response.json(); } catch { body = null; }
        return { status: response.status, body };
      })
      .then(({ status, body }) => {
        if (status === 200 && body && body.tipoProduto) {
          this.getProdutos(body.tipoProduto);
        } else {
          const mensagem = body?.message || "Não foi possível carregar o tipo de produto.";
          this.setState({ produtos: [], placeholder: mensagem, produtoDisabled: true });
          this.exibirErroSwal(mensagem);
        }
      })
      .catch(() => {
        const mensagem = "Erro ao carregar tipos de produto.";
        this.setState({ produtos: [], placeholder: mensagem, produtoDisabled: true });
        this.exibirErroSwal(mensagem);
      });
  }

  getProdutos(tipoProduto) {
    let requestOptions;
    const labcnpj = this.props.labcnpj;
    const cnpjLimpo = CnpjUtils.cleanCnpj(this.props?.dados_empresa_faturamento_cnpj);

    const hasSimulacaoLab = this.context.userSession.modulos.includes("Pedido e Simulação Laboratórios");
    const isEssilor = this.context.userSession.papelCategoria === "ESSILOR";
    const hasRede = this.props?.redes?.length > 0 && this.context.userSession.redeOticas;
    const podeConsultarComOtica = hasRede || isEssilor || hasSimulacaoLab;

    if (podeConsultarComOtica && cnpjLimpo.length !== 14) {
      this.setState({ produtos: [], placeholder: "Informe o CNPJ da empresa de faturamento", produtoDisabled: true });
      return;
    }

    if (podeConsultarComOtica) {
      requestOptions = {
        method: "GET",
        headers: {
          access_token: sessionStorage.getItem("token"),
          client_id: localStorage.getItem("clientid"),
          laboratorio: labcnpj,
          otica: cnpjLimpo,
        },
      };
    } else {
      requestOptions = {
        method: "GET",
        headers: {
          access_token: sessionStorage.getItem("token"),
          client_id: localStorage.getItem("clientid"),
          laboratorio: labcnpj,
        },
      };
    }

    const url = `${process.env.REACT_APP_ESSILOR_API}gestao-produtos-laboratorio/v1/linhas-produtos-atacado?tipoProduto=${tipoProduto}`;

    fetch(url, requestOptions)
      .then(async response => {
        let body = null;
        try { body = await response.json(); } catch { body = null; }
        return { status: response.status, body };
      })
      .then(({ status, body }) => {
        if (status === 200 && Array.isArray(body) && body.length > 0) {
          this.setState({ produtos: body, placeholder: `${body.length} resultados encontrados`, produtoDisabled: false });
          return;
        }

        const mensagem = (Array.isArray(body) && body[0]?.mensagem) || body?.mensagem || "Nenhum produto encontrado.";
        this.setState({ produtos: [], placeholder: "Nenhum produto encontrado", produtoDisabled: true });
        this.exibirErroSwal(mensagem);
      })
      .catch(() => {
        const mensagem = "Erro ao carregar produtos.";
        this.setState({ produtos: [], placeholder: mensagem, produtoDisabled: true });
        this.exibirErroSwal(mensagem);
      });
  }

  handleChangeAutocomplete(item) {
    if (item) {
      if (this.props.clearHighlight) {
        this.props.clearHighlight("inputProduto");
      }
      this.props.onChange(
        {
          linhaProduto: { codigo: item.value, nome: item.label },
          produtos: [],
          rpl: "",
          produtoResolvido: false,
        },
        () => {
          if (this.props.onProdutoChange) {
            this.props.onProdutoChange();
          }
        },
      );
    } else {
      this.props.onChange({
        linhaProduto: { codigo: "", nome: "" },
        produtos: [],
        rpl: "",
        produtoResolvido: false,
      });
    }
  }

  handleVoucherCodeChange = (value) => {
    const clean = value.replace(/-/g, "");
    const isComplete = clean.length === 32;
    this.setState({ voucherPactoCode: value });
    this.props.onChange({
      pacto: {
        ...this.props.pacto,
        useVoucher: isComplete,
        selectedVoucher: clean.length > 0 ? { codigo: value } : null,
        voucherIncompleto: clean.length > 0 && !isComplete,
      },
    });
  };

  aplicarVoucherOptilab = () => {
    if (this.state.voucherPactoCode) {
      this.props.onChange({
        pacto: {
          ...this.props.pacto,
          useVoucher: true,
          selectedVoucher: { codigo: this.state.voucherPactoCode },
        },
      });
    }
  };

  clearVoucherSelection = () => {
    this.props.onChange({
      pacto: {
        ...this.props.pacto,
        useVoucher: false,
        selectedVoucher: null,
      },
    });
  };

  toggleVoucherPilar = (pilar) => {
    if (this.state.selectedPilar === pilar) {
      this.setState({ selectedPilar: "" });
    } else {
      const vouchers = this.props.pacto?.vouchers || [];
      const selected = vouchers.find(v => (v.descPilar || v.pilar) === pilar);
      if (selected && selected.listaVouchers?.length > 0) {
        const voucherAplicado = selected.listaVouchers[0];
        this.setState({ selectedPilar: pilar });
        this.props.onChange({
          pacto: {
            ...this.props.pacto,
            useVoucher: true,
            selectedVoucher: {
              id: voucherAplicado.idVoucher || voucherAplicado.id,
              codigo: voucherAplicado.codigoVoucher || voucherAplicado.codigo,
              pilar: selected.descPilar || selected.pilar,
            },
          },
        });
      }
    }
  };

  render() {
    const { disableFields, IsPacto, pacto, laboratorio } = this.props;
    const isPactoNovaJornada = laboratorio?.PactoNovaJornada || false;
    const showVoucherSection = IsPacto && pacto?.temVoucher && this.props.linhaProduto?.codigo;
    const selectedProduto = this.props.linhaProduto?.codigo ? { value: this.props.linhaProduto.codigo, label: this.props.linhaProduto.nome } : null;

    return (
      <div>
        <div className="row" style={{ marginBottom: "1.5rem" }}>
          <div className="col-12 col-md-6">
            <Input
              id="input-tipo-producao"
              name="tipo_producao"
              type="text"
              label="Tipo de produção"
              aria="Tipo de produção"
              width="100%"
              value="Lente Pronta"
              readOnly={true}
              disabled={true}
              onChange={() => {}}
            />
          </div>
          <div className="col-12 col-md-6">
            <Input
              id="input-tipo-produto"
              name="tipo_produto"
              type="text"
              label="Tipo de produto"
              aria="Tipo de produto"
              width="100%"
              value="Visão Simples"
              readOnly={true}
              disabled={true}
              onChange={() => {}}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <AutoCompleteSelect
              ref={this.autoRef}
              className="inputProduto"
              width="100%"
              name="produto"
              id="inputProduto"
              label="Escolha o produto*"
              aria="Selecione um produto"
              options={this.state.produtos}
              defaultValue={selectedProduto}
              placeholder={this.state.placeholder}
              onChange={this.handleChangeAutocomplete}
              disabled={disableFields || this.state.produtoDisabled || this.props.resolvendoProduto || this.props.buscandoVoucher}
              readOnly={disableFields}
              noOptionsMessage={this.state.placeholder}
              tooltip="A consulta pode ser feita pelo código ou pelo nome do produto."
              style={{ marginRight: "0" }}
            />
            {isPactoNovaJornada && this.props.resolvendoProduto && (
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "8px" }}>
                <CircularProgress size={16} style={{ color: "#0066B3" }} />
                <Typography variant="caption" color="textSecondary">Buscando produto...</Typography>
              </div>
            )}
          </div>
        </div>

        <Collapse in={showVoucherSection && !isPactoNovaJornada} timeout={400}>
          <div className="lp-voucher-section mt-4">
            <p className="lp-voucher-section__title">
              Vouchers Pacto disponíveis para este produto, deseja aplicar?
            </p>
            <p className="lp-voucher-section__subtitle">
              Confira mais detalhes dos seus vouchers acessando o{" "}
              <a id="link-programa-pacto" href="https://www.programapactoessilor.com.br/login" className="lp-voucher-section__link" target="_blank" rel="noopener noreferrer">Programa Pacto</a>.
            </p>
            <TableContainer component={Paper} elevation={3} variant="outlined">
              <Table size="medium">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ color: "#0066B3", fontWeight: 600 }}>Pilar</TableCell>
                    <TableCell style={{ color: "#0066B3", fontWeight: 600 }}>Quantidade</TableCell>
                    <TableCell style={{ color: "#0066B3", fontWeight: 600 }} align="center">Selecionar</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(pacto?.vouchers || []).map((v, idx) => {
                    const pilarNome = v.descPilar || v.pilar;
                    const isSelected = this.state.selectedPilar === pilarNome && !!pacto?.useVoucher;
                    return (
                      <TableRow
                        key={idx}
                        id={`voucher-row-${(pilarNome || "").toLowerCase().replace(/\s+/g, '-')}`}
                        hover
                        onClick={() => this.toggleVoucherPilar(pilarNome)}
                        style={{ cursor: "pointer", backgroundColor: isSelected ? "rgba(0, 102, 179, 0.08)" : undefined }}
                      >
                        <TableCell>{pilarNome}</TableCell>
                        <TableCell>{v.listaVouchers?.length || 0}</TableCell>
                        <TableCell align="center">
                          <Radio
                            checked={isSelected}
                            size="small"
                            style={{ padding: 0, color: isSelected ? "#0066B3" : undefined }}
                            inputProps={{ "aria-label": `Selecionar ${pilarNome}` }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Collapse in={!!(this.state.selectedPilar && pacto?.useVoucher)} timeout={300} onExited={this.clearVoucherSelection}>
              <div id="voucher-applied-badge" className="lp-voucher-applied">
                <CheckCircleOutlineIcon className="lp-voucher-applied__icon" />
                <span style={{ flex: 1 }}>Voucher <strong>{pacto.selectedVoucher?.codigo}</strong> aplicado ao pedido</span>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => this.toggleVoucherPilar(this.state.selectedPilar)}
                  startIcon={<CloseIcon />}
                  style={{ color: "#388e3c", borderColor: "#388e3c", textTransform: "none", alignSelf: "center", whiteSpace: "nowrap" }}
                >
                  Cancelar seleção
                </Button>
              </div>
            </Collapse>
          </div>
        </Collapse>


        <Collapse in={!isPactoNovaJornada && IsPacto && !!this.props.linhaProduto?.codigo && this.props.buscandoVoucher} timeout={300}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px", paddingTop: "3.5rem", paddingBottom: "1rem" }}>
            <CircularProgress size={22} style={{ color: "#0066B3" }} />
            <Typography variant="subtitle2" color="textSecondary">
              Verificando vouchers disponíveis...
            </Typography>
          </div>
        </Collapse>

        <Collapse in={!isPactoNovaJornada && !showVoucherSection && IsPacto && !!this.props.linhaProduto?.codigo && !!pacto?.tentativaConcluida && !this.props.buscandoVoucher} timeout={400}>
          <VoucherEmpty title="Voucher Pacto" divider />
        </Collapse>

        <Collapse in={isPactoNovaJornada} timeout={400}>
          <div id="voucher-manual-section" className="lp-voucher-section mt-4">
            <p className="lp-voucher-section__title">Voucher Pacto</p>
            <p className="lp-voucher-section__subtitle">
              Caso possua um Voucher Pacto, insira o código no campo abaixo.
            </p>
            <VoucherInput
              id="input-voucher-pacto-code"
              label="Código do voucher"
              value={this.state.voucherPactoCode}
              onChange={this.handleVoucherCodeChange}
              onBlur={() => this.setState({ voucherBlurred: true })}
              disabled={disableFields}
            />
            <Collapse in={pacto?.useVoucher && this.state.voucherPactoCode.replace(/-/g, "").length === 32} timeout={300}>
              <div id="voucher-informed-badge" className="lp-voucher-informed mt-3">
                <span className="lp-voucher-informed__icon">ℹ</span>
                <span>Voucher Pacto informado — será validado no envio do pedido</span>
              </div>
            </Collapse>
            <p className="lp-voucher-section__subtitle mt-3" style={{ marginBottom: 0 }}>
              Confira mais detalhes dos seus vouchers acessando o{" "}
              <a id="link-programa-pacto-info" href="https://www.programapactoessilor.com.br/login" className="lp-voucher-section__link" target="_blank" rel="noopener noreferrer">Programa Pacto</a>.
            </p>
          </div>
        </Collapse>
      </div>
    );
  }
}

export default LenteProntaEtapaDois;
